import MutedText from "../../ui/MutedText";
import InfoTooltip from "../../ui/InfoTooltip";

const SectionHeading = ({ children, count, tooltip }) => (
  <div className="px-3 flex items-center justify-between">
    <div className="inline-flex min-w-0 items-center gap-1.5 text-sm text-gray-300 select-none">
      <span className="truncate">{children}</span>
      <MutedText as="span">({count})</MutedText>
      <InfoTooltip text={tooltip} widthClass="w-72" />
    </div>
  </div>
);

export default SectionHeading;
